"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
  query Analytics($query: AnalyticsQueryInput!) {
    orderAnalytics(query: $query) {
      label
      type
      interval
      intervalOptions
      coordinates {
        x
        y
      }
      segments {
        label
        type
        coordinates {
          x
          y
        }
      }
    }
  }
`;
exports.default = query;
//# sourceMappingURL=analytics.query.js.map